import {
  cyrillicToLatin,
  simplifyLatin,
} from '../../../shared/utils/transliteration';

export const ADMIN_USERNAME_PATTERN =
  /^[a-z0-9]+(?:-[a-z0-9]+)*(?:\.[a-z0-9]+(?:-[a-z0-9]+)*)+$/;

export const ADMIN_PIN_LENGTH = 5;
export const ADMIN_PIN_PATTERN = /^\d{5}$/;

// Isto pravilo kao na beku: "Đorđe Šćekić" -> "djordje.scekic".
const toUsernamePart = (value) =>
  simplifyLatin(cyrillicToLatin(value || ''))
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .split(/[^a-z0-9]+/)
    .filter(Boolean)
    .join('-');

export const buildAdminUsername = (firstName, lastName) =>
  [toUsernamePart(firstName), toUsernamePart(lastName)]
    .filter(Boolean)
    .join('.');

export const normalizeAdminUsername = (value) =>
  (value || '').trim().replace(/^@+/, '').toLowerCase();

export const onlyPinDigits = (value) =>
  (value || '').replace(/\D/g, '').slice(0, ADMIN_PIN_LENGTH);
